import locationHttpService from '../../../../../frontend/global/modules/Locations/services/locationHttpService';
import { LOCATION_TYPE } from '../../../../../frontend/global/modules/Locations/api/enums/location-types';
import httpService from '../../../services/http-service';
import { BaseAutocompleteParams } from '../types/BaseAutocompleteParams';
import { OptionsByIdsApiCall } from '../types/OptionsByIdsApiCall';
import { AutocompleteApiCall } from '../types/AutocompleteApiCall';
import { RouteBasedLocationAutocompleteParams } from './types/RouteBasedLocationAutocompleteParams';
import { TruckLocationAutocompleteOption } from './types/TruckLocationAutocompleteOption';
import { SeaLocationAutocompleteOption } from './types/SeaLocationAutocompleteOption';
import { AirLocationAutocompleteOption } from './types/AirLocationAutocompleteOption';
import { LocationAutocompleteParams } from './types/LocationAutocompleteParams';
import { RoutesBasedLocationData } from './types/RoutesBasedLocationData';
import { LocationData } from './types/LocationData';
import { prepareLocaitonOptions } from './utils';

export const getAirportSuggestions: AutocompleteApiCall = async ({ params, abortSignal }) => {
  const { data } = await httpService.get(
    '/api/v3/autocomplete/airports/suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getSeaportSuggestions: AutocompleteApiCall = async ({ params, abortSignal }) => {
  const { data } = await httpService.get(
    '/api/v3/autocomplete/seaports/suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getRoutesBasedDestinationSuggestions: AutocompleteApiCall<RouteBasedLocationAutocompleteParams, RoutesBasedLocationData> = async ({ params, abortSignal }) => {
  const { data } = await locationHttpService.get(
    '/api/v1/autocomplete/routes/destination_suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getCitiesSuggestions: AutocompleteApiCall = async ({ params, abortSignal }) => {
  const { data } = await locationHttpService.get(
    '/api/v1/autocomplete/locations/city_suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getVenueSuggestions: AutocompleteApiCall = async ({ params, abortSignal }) => {
  const { data } = await httpService.get(
    '/api/v3/autocomplete/locations/venue_suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getSeaLocationsSuggestions: AutocompleteApiCall<BaseAutocompleteParams, SeaLocationAutocompleteOption> = async ({ params, abortSignal }) => {
  const { data } = await locationHttpService.get(
    '/api/v1/autocomplete/locations/ocean_suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getAirLocationsSuggestions: AutocompleteApiCall<BaseAutocompleteParams, AirLocationAutocompleteOption> = async ({ params, abortSignal }) => {
  const { data } = await locationHttpService.get(
    '/api/v1/autocomplete/locations/air_suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getTruckLocationsSuggestions: AutocompleteApiCall<BaseAutocompleteParams, TruckLocationAutocompleteOption> = async ({ params, abortSignal }) => {
  const { data } = await locationHttpService.get(
    '/api/v1/autocomplete/locations/ground_suggestions',
    params,
    abortSignal
  );
  return data;
};

export const getLocationsSuggestions: AutocompleteApiCall<LocationAutocompleteParams, LocationData> = async ({ params, abortSignal }) => {
  const { data } = await locationHttpService.get(
    '/api/v1/autocomplete/locations/suggestions',
    params,
    abortSignal
  );

  if (Array.isArray(data)) {
    return prepareLocaitonOptions(data);
  }

  return {
    after_key: data.after_key,
    data: prepareLocaitonOptions(data.data),
  };
};

export const getLocationsByIds: OptionsByIdsApiCall<{ id: number; label: string; type: LOCATION_TYPE }> = async ({ params, abortSignal }) => {
  const { data } = await locationHttpService.get(
    '/api/v1/autocomplete/locations/location_names',
    { ids: params },
    abortSignal
  );
  return prepareLocaitonOptions(data);
};